import { Discounts } from '@prisma/client';
import { AxiosError } from 'axios';
import API_URL from '../apiconfig';
import axios from './api';
import { DiscountPayload } from '../types/discounts';

export const getDiscounts = async (
  businessId: string,
  {
    activeOnly,
  }: {
    activeOnly?: boolean;
  } = {},
) => {
  try {
    const discounts = await axios.get(`${API_URL}/v1/discounts`, {
      params: {
        businessId,
        activeOnly,
      },
    });

    return discounts.data.result as Discounts[];
  } catch (error) {
    throw new Error('Cannot get business', { cause: error });
  }
};

export const createDiscount = async (
  businessId: string,
  body: DiscountPayload,
) => {
  try {
    const discount = await axios.post(`${API_URL}/v1/discounts`, {
      ...body,
      businessId,
    });

    return discount.data.result as Discounts;
  } catch (error) {
    if ((error as AxiosError).response?.status === 409) {
      throw new Error('Discount code already exists', { cause: error });
    }
    throw new Error('Failed to create discount', { cause: error });
  }
};

export const updateDiscount = async ({
  discountId,
  businessId,
  body,
}: {
  discountId: string;
  businessId: string;
  body: DiscountPayload;
}) => {
  try {
    const discount = await axios.patch(
      `${API_URL}/v1/discounts/${discountId}`,
      { ...body, businessId },
    );

    return discount.data.result as Discounts;
  } catch (error) {
    if ((error as AxiosError).response?.status === 409) {
      throw new Error('Discount code already exists', { cause: error });
    }
    throw new Error('Failed to update discount', { cause: error });
  }
};

export const applyDiscountToPrice = (
  price: number,
  discount: Discounts,
  priceType: 'cents' | 'dollars' = 'cents',
) => {
  if (discount.type === 'PERCENTAGE') {
    return Math.max(price - price * discount.amount, 0);
  }

  const fixedAmount =
    priceType === 'cents' ? discount.amount : discount.amount / 100;
  return Math.max(price - fixedAmount, 0);
};
